import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-tenant-update',
  templateUrl: './tenant-update.component.html',
  styleUrls: ['./tenant-update.component.css', '../license/license.component.css', '../../assets/css/button.css',
    '../../assets/css/label.css'
    , '../../assets/css/grid.css', '../../assets/css/containers.css', '../../assets/css/textfield.css'
    , '../../assets/css/checkbox.css', '../../assets/css/CGM-G3Symbols.css']
})
export class TenantUpdateComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  redirectToTenantApplication() {
    window.location.reload();
  }
}
